import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useOrganizationStore } from '@/stores/organization';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const selectedOrgId = useOrganizationStore((s) => s.selectedOrg?._id);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Mobile sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        {/* Mobile header with hamburger */}
        <Header
          title="VIDA System"
          onMenuClick={() => setSidebarOpen(true)}
          showBell
        />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          {/* key={selectedOrgId} forces a re-mount when the user switches org,
              so all child pages re-fetch their data with the new X-Org-Id. */}
          <Outlet key={selectedOrgId || 'no-org'} context={{ setSidebarOpen }} />
        </main>
      </div>
    </div>
  );
}
